/*----------------------------------
- HOME: HERO PERSONA CALLS TO ACTION
----------------------------------*/

/**
 * The hero's two calls to action as v3 draws them (`.ctas`): the marketing `PersonaPair` on the world (`onWorld`,
 * batch 6 S2b), "I'm an investor" in the white soft pill and "I'm a founder" in the ink pill (Home v3, W3), both the kit's `cta`
 * with the go circle. Each opens sign-up as that persona (`personaSource: 'chosen'`), so the modal's persona screen
 * opens on it, preselected, for the visitor to confirm.
 *
 * @docs docs/features/website-landing-experience
 * @adr  ADR-0110
 * @rule The conversion path is frozen: the hrefs come from `buildLandingPersonaSignupHref` with the hero's attribution,
 *       the clicks fire the catalogued `website_landing_hero_investor` / `_founder` ids, and every link keeps
 *       the pair's test id `persona-auth-cta`, `data-persona` and `data-attribution` (persona-auth-cta-contract).
 */

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import type { ConversionTriggerId } from '@uniquedomains/components/contracts/analytics/conversionTriggers';
import { PersonaPair } from '@uniquedomains/components/marketing/persona-pair/PersonaPair';

import { buildLandingPersonaSignupHref, type LandingSignupPersona } from '@/client/catalogs/landing/publicLinks';
import { HOME_HERO_COPY } from '@/client/catalogs/landing/home/homeCopy';
import { trackConversionTrigger } from '@/client/pages/landing/lib/trackConversionTrigger';
import { trackLandingCta } from '@/client/pages/landing/lib/trackLandingCta';

/*----------------------------------
- CONSTANTS
----------------------------------*/

const HERO_ATTRIBUTION = 'website_landing_hero';
const TRACKING_PAGE = 'landing_home';
const TRACKING_SECTION = 'hero';

/*----------------------------------
- COMPONENT
----------------------------------*/

const HomeHeroCtas = () => {
    const investorHref = buildLandingPersonaSignupHref('investor', HERO_ATTRIBUTION);
    const founderHref = buildLandingPersonaSignupHref('founder', HERO_ATTRIBUTION);
    const trackEntry = (persona: LandingSignupPersona, href: string, triggerId: ConversionTriggerId) => {
        trackLandingCta({ page: TRACKING_PAGE, section: TRACKING_SECTION, label: HOME_HERO_COPY.personaCtas[persona], kind: 'persona', href, surface: 'hero' });
        trackConversionTrigger(triggerId, { href, page: TRACKING_PAGE, section: TRACKING_SECTION, context: { persona } });
    };

    return (
        <PersonaPair
            onWorld
            class="ctas"
            investor={{ label: HOME_HERO_COPY.personaCtas.investor, href: investorHref, attribution: HERO_ATTRIBUTION, onClick: () => trackEntry('investor', investorHref, 'website_landing_hero_investor') }}
            founder={{ label: HOME_HERO_COPY.personaCtas.founder, href: founderHref, attribution: HERO_ATTRIBUTION, onClick: () => trackEntry('founder', founderHref, 'website_landing_hero_founder') }}
        />
    );
};

export default HomeHeroCtas;
